module.exports = {
	closeText: 'St&auml;ng',
	prevText: '&#xAB;F&ouml;rra',
	nextText: 'N&auml;sta&#xBB;',
	currentText: 'Idag',
	monthNames: ['januari', 'februari', 'mars', 'april', 'maj', 'juni',
		'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
	monthNamesShort: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni',
		'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	dayNamesShort: ['s&ouml;n', 'm&ouml;n', 'tis', 'ons', 'tor', 'fre', 'l&ouml;r'],
	dayNames: ['s&ouml;ndag', 'm&aring;ndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'l&ouml;rdag'],
	dayNamesMin: ['s&ouml;', 'm&aring;', 'ti', 'on', 'to', 'fr', 'l&ouml;'],
	weekHeader: 'Ve',
	dateFormat: 'yy-mm-dd',
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: ''
};
